<div class="app-shell">
  <div class="card">
    <header class="card__header">
      <h1>{{ title }}</h1>
      <p>
        Capture the core details about your product or service before running
        AI-driven analysis.
      </p>
    </header>

    <section class="card__body">
      <div class="home-secondary-actions">
        <button type="button" class="button button--ghost" routerLink="/records">
          View Previous Records
        </button>
      </div>
      <form [formGroup]="collectForm" (ngSubmit)="onSubmit()" novalidate>
        <div class="grid">
          <label class="field">
            <span class="field__label">Record Type</span>
            <select formControlName="type" class="field__input">
              <option value="" disabled>Select type</option>
              <option
                *ngFor="let option of typeOptions"
                [value]="option.value"
              >
                {{ option.label }}
              </option>
            </select>
            <span class="field__hint">
              Choose what kind of entity you are collecting data for.
            </span>
            <span
              class="field__error"
              *ngIf="controls.type.invalid && controls.type.touched"
            >
              Type is required.
            </span>
          </label>

          <label class="field">
            <span class="field__label">Name</span>
            <input
              type="text"
              formControlName="name"
              class="field__input"
              placeholder="e.g. Premium SEO Suite"
            />
            <span class="field__hint">
              The marketing name your team or customers use.
            </span>
            <span
              class="field__error"
              *ngIf="controls.name.invalid && controls.name.touched"
            >
              A descriptive name up to 150 characters is required.
            </span>
          </label>
        </div>

        <div class="grid">
          <label class="field">
            <span class="field__label">Business Type</span>
            <input
              type="text"
              formControlName="business_type"
              class="field__input"
              placeholder="e.g. SaaS, Agency, Retail"
            />
            <span class="field__hint">
              What category best represents how the offering is delivered?
            </span>
            <span
              class="field__error"
              *ngIf="
                controls.business_type.invalid && controls.business_type.touched
              "
            >
              Provide the business type (e.g., SaaS platform).
            </span>
          </label>

          <label class="field">
            <span class="field__label">Primary Location</span>
            <input
              type="text"
              formControlName="location"
              class="field__input"
              placeholder="City, Region, Country"
            />
            <span class="field__hint">
              Where is the business or campaign primarily active?
            </span>
            <span
              class="field__error"
              *ngIf="controls.location.invalid && controls.location.touched"
            >
              Location is required. Include city and country if possible.
            </span>
          </label>
        </div>

        <label class="field field--full">
          <span class="field__label">Description</span>
          <textarea
            formControlName="description"
            class="field__textarea"
            rows="6"
            placeholder="Summarize the product/service, use cases, audience, and differentiators."
          ></textarea>
          <span class="field__hint">
            Minimum 20 characters. Share selling points, audience, or current
            campaign goals.
          </span>
          <span
            class="field__error"
            *ngIf="
              controls.description.invalid && controls.description.touched
            "
          >
            Please provide a description between 20 and 1500 characters.
          </span>
        </label>

        <div class="form__footer">
          <div class="form__status">
            <span class="status status--success" *ngIf="successMessage()">
              {{ successMessage() }}
              <ng-container *ngIf="responseId()"
                >Saved ID: {{ responseId() }}</ng-container
              >
            </span>
            <span class="status status--error" *ngIf="errorMessage()">
              {{ errorMessage() }}
            </span>
          </div>

          <div class="form__actions">
            <button
              type="button"
              class="button button--secondary"
              (click)="resetForm()"
              [disabled]="loading()"
            >
              Reset
            </button>
            <button
              type="submit"
              class="button button--primary"
              [disabled]="loading()"
            >
              <span *ngIf="!loading()">Submit</span>
              <span *ngIf="loading()" class="spinner">
                <span class="spinner__dot"></span>
                <span class="spinner__text">Saving...</span>
              </span>
            </button>
          </div>
        </div>
      </form>

      <ng-container *ngIf="responseId()">
        <div class="post-submit-actions">
          <button
            type="button"
            class="button button--primary"
            (click)="goToAudiences()"
          >
            View Target Audience Profiles
          </button>
        </div>
      </ng-container>
    </section>
  </div>
</div>





